import {
  SET_GROUND_WIDTH, SET_GROUND_HEIGHT, SET_GROUND_DEPTH,
  SET_GROUND_C1X, SET_GROUND_C1Y, SET_GROUND_C2X, SET_GROUND_C2Y,
  SET_PEDESTAL_PEDESTAL_DEPTH, SET_PEDESTAL_PEDESTAL_HEIGHT,
  SET_PEDESTAL_FINISH_DEPTH,
  SET_PEDESTAL_GROUND_DEPTH,
  SET_MASONRY_TEXTURE_COLOR,
  RESET_GROUND,
  SET_GROUND_OPTIONS,
  SET_GROUND_STATE
} from '@reducers/options/ground/actions';

import generalCalculationDefault from './defaults/generalCalculation';
import bracketAttachmentDefault from './defaults/bracketAttachment';
import safetyBarrierDefault from './defaults/safetyBarrier';
import rebarReinforcementDefault from './defaults/rebarReinforcement';
import woodConnectionDefault from './defaults/woodConnection';
import { APP_TYPES } from '@config';

import merge from '@services/deepmerge';
import { mergeDeep } from '@services/helper.service';

export default (state = mergeDeep({}, generalCalculationDefault), action) => {
  switch (action.type) {
    case RESET_GROUND: {
      let options = null;

      switch (action.appType) {
        case APP_TYPES.GENERAL_CALCULATION: {
          options = mergeDeep({}, generalCalculationDefault);
          break;
        }
        case APP_TYPES.BRACKET_ATTACHMENT: {
          options = mergeDeep({}, bracketAttachmentDefault);
          break;
        }
        case APP_TYPES.SAFETY_BARRIER: {
          options = mergeDeep({}, safetyBarrierDefault);
          break;
        }
        case APP_TYPES.REBAR_REINFORCEMENT: {
          options = mergeDeep({}, rebarReinforcementDefault);
          break;
        }
        case APP_TYPES.WOOD_CONNECTION: {
          options = mergeDeep({}, woodConnectionDefault);
          break;
        }
        default: {
          options = state;
          break;
        }
      }

      return { ...options };
    }
    case SET_GROUND_STATE: {
      return action.state;
    }
    case SET_GROUND_WIDTH: {
      state.width = action.value;

      return { ...state };
    }
    case SET_GROUND_HEIGHT: {
      state.height = action.value;

      return { ...state };
    }
    case SET_GROUND_DEPTH: {
      return merge(state, {
        depth: action.value || null
      });
    }
    case SET_GROUND_C1X: {
      return merge(state, {
        padding: {
          C1x: action.value
        }
      });
    }
    case SET_GROUND_C1Y: {
      return merge(state, {
        padding: {
          C1y: action.value
        }
      });
    }
    case SET_GROUND_C2X: {
      return merge(state, {
        padding: {
          C2x: action.value
        }
      });
    }
    case SET_GROUND_C2Y: {
      return merge(state, {
        padding: {
          C2y: action.value
        }
      });
    }
    // case SET_GROUND_PADDING: {
    //   for (const key of Object.keys(action.padding)) {
    //     state.padding[key] = action.padding[key] || null;
    //   }

    //   return { ...state };
    // }

    case SET_PEDESTAL_PEDESTAL_DEPTH: {
      state.pedestal.pedestal.depth = action.value;

      return { ...state };
    }
    case SET_PEDESTAL_PEDESTAL_HEIGHT: {
      state.pedestal.pedestal.height = action.value;

      return { ...state };
    }
    case SET_PEDESTAL_FINISH_DEPTH: {
      state.pedestal.finish.depth = action.value;

      return { ...state };
    }
    case SET_PEDESTAL_GROUND_DEPTH: {
      state.pedestal.ground.depth = action.value;

      return { ...state };
    }

    case SET_MASONRY_TEXTURE_COLOR: {
      return mergeDeep({}, state, {
        masonryTextureColor: action.value
      });
    }
    case SET_GROUND_OPTIONS: {
      return merge(state, action.options);
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/ground/index.js